import classNames from 'classnames';
import React from 'react';
import { FCC } from 'react';
import { IHeadingProps } from './types';

import './Heading.scss';

export const Heading: FCC<IHeadingProps> = (props) => {
  const { text, h = 2, underline = true, uppercase = false } = props;

  const Tag: any = 'h' + h;

  const classes = classNames({
    'hlc-heading': true,
    'hlc-heading-underline': underline,
    'hlc-heading-uppercase': uppercase,
  });

  const controls = props.renderIcons ? props.renderIcons() : null;
  return (
    <div className={classes} qa-id={props['qa-id']}>
      <Tag title={text}>{text}</Tag>
      {controls && <div>{controls}</div>}
    </div>
  );
};

export default Heading;
